import { flow } from 'fp-ts/function';
import { at, cond, constant, get, isEqual, isNil, spread, stubString, T } from 'lodash/fp';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedCurrencyValue, LocalizedNumber } from '@mews/framework';
import { WithDataTestId } from '@mews-commander/types';
import { Amount } from '@mews-commander/data-access';
import { SpacedDash } from '@mews-commander/ui';

interface MaxAmountProps {
    max: Amount;
}

interface MaxNumberProps {
    max: number;
}

const isMaxValueNil = flow(get('max'), isNil);
const hasNoRange = flow(at(['min', 'max']), spread(isEqual));

export const handleMaxValue = (MaxValueComponent: $TSFixMe) =>
    cond([
        [isMaxValueNil, constant(UnicodeEntity.PlusSign)],
        [hasNoRange, stubString],
        [
            T,

            // @ts-expect-error $TSFixMeError: Type 'Element' is not assignable to type 'string'.
            ({ max, dataTestId }) => (
                <>
                    {SpacedDash}
                    <MaxValueComponent max={max} dataTestId={dataTestId} />
                </>
            ),
        ],
    ]);

const MaxNumber = handleMaxValue(({ max, dataTestId }: MaxNumberProps & WithDataTestId) => (
    <LocalizedNumber number={max} data-test-id={dataTestId} />
));

const MaxAmount = handleMaxValue(({ max, dataTestId }: MaxAmountProps & WithDataTestId) => (
    <LocalizedCurrencyValue value={max} data-test-id={dataTestId} />
));

export const NumberRangeText = ({
    min = 0,
    max,
    minDataTestId = 'minNumber-range',
    maxDataTestId = 'maxNumber-range',
}: $TSFixMe) => (
    <>
        <LocalizedNumber number={min} data-test-id={minDataTestId} />

        {/* @ts-expect-error $TSFixMeError: 'MaxNumber' cannot be used as a JSX component. */}
        <MaxNumber min={min} max={max} dataTestId={maxDataTestId} />
    </>
);

export const AmountRangeText = ({
    min,
    max,
    minDataTestId = 'minAmount-range',
    maxDataTestId = 'maxAmount-range',
}: $TSFixMe) => (
    <>
        <LocalizedCurrencyValue value={min || { currency: max.currency, value: 0 }} data-test-id={minDataTestId} />

        {/* @ts-expect-error $TSFixMeError: 'MaxAmount' cannot be used as a JSX component. */}
        <MaxAmount min={min} max={max} dataTestId={maxDataTestId} />
    </>
);
